import React from 'react';

export default function DashboardHome() {
  const stats = [
    { title: 'Total Students', value: '2,450', icon: '👨‍🎓', color: '#4CAF50' },
    { title: 'Present Today', value: '2,100', icon: '✅', color: '#2196F3' },
    { title: 'Absent Today', value: '350', icon: '❌', color: '#F44336' },
    { title: 'Fee Collected', value: '₹42.5L', icon: '💰', color: '#9C27B0' },
  ];

  const cards = [
    { title: 'Circulars', count: 4, icon: '📄' },
    { title: 'Holidays', count: 2, icon: '🏖️' },
    { title: 'Events', count: 3, icon: '🎉' },
    { title: 'Assignments', count: 12, icon: '📚' },
  ];

  const updates = [
    { text: 'Final exams schedule released for Semester 6', time: '2h ago' },
    { text: 'Fee deadline extended to 30th April', time: '5h ago' },
    { text: 'New ID cards available at Admin Office', time: '1d ago' },
  ];

  return (
    <div className="dash-page">
      <h1>Dashboard Overview</h1>
      <div className="stats-grid">
        {stats.map((s,i) => (
          <div key={i} className="stat-card" style={{borderTop: `4px solid ${s.color}`}}>
            <span className="stat-icon">{s.icon}</span>
            <div><h3>{s.value}</h3><p>{s.title}</p></div>
          </div>
        ))}
      </div>
      <div className="dash-grid">
        <div className="quick-section">
          <h2>Quick Cards</h2>
          <div className="quick-grid">
            {cards.map((c,i) => (
              <div key={i} className="quick-card">
                <span className="q-icon">{c.icon}</span>
                <div><h4>{c.title}</h4><p>{c.count} Active</p></div>
              </div>
            ))}
          </div>
        </div>
        <div className="recent-section">
          <h2>Latest Updates</h2>
          <ul className="update-list">
            {updates.map((u,i) => (
              <li key={i}><span>{u.text}</span><span className="time">{u.time}</span></li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}